module.exports = __webpack_public_path__ + "static/media/qixingshan_plant.fff7fa78.webp";